import { useState } from "react";
import { useNavigate } from "react-router-dom";
import bg from "../../assets/login-background.jpg";
import logo from "../../assets/waseeny-logo.png";
import { useLang } from "../../context/LanguageContext";
import { useTranslate } from "../../Hook/useTranslate";
function Language() {
  const t = useTranslate();
  const navigate = useNavigate();
  const [selected, setSelected] = useState("en");
const { setLang } = useLang();

const handleConfirm = () => {
  setLang(selected);
  localStorage.setItem("language", selected);

  //  RTL support
  document.body.dir = selected === "ar" ? "rtl" : "ltr";

  navigate("/intro");
};
  

  return (
    <div style={styles.container}>

      {/*  Top Section with Image and Logo inside */}
      <div style={styles.topSection}>
        <img src={bg} style={styles.topImage} />
        <img src={logo} style={styles.logo} />
      </div>

      {/*  Text */}
      <h2 style={styles.title}>{t("chooseLang")}</h2>
      <p style={styles.subtitle}>
        Select your preferred language to personalize your experience
      </p>

      {/*  Buttons */}
      <div style={styles.buttonGroup}>
        <button 
          style={selected === "en" ? styles.activeBtn : styles.btn} 
          onClick={() => setSelected("en")}
        >
          English {selected === "en" && "✓"}
        </button>

        <button 
          style={selected === "de" ? styles.activeBtn : styles.btn} 
          onClick={() => setSelected("de")}
        >
          German {selected === "de" && "✓"}
        </button>

        <button 
          style={selected === "ar" ? styles.activeBtn : styles.btn} 
          onClick={() => setSelected("ar")}
        >
          عربي {selected === "ar" && "✓"}
        </button>
      </div>

      {/*  Bottom Button */}
      <button style={styles.selectBtn} onClick={handleConfirm}>Select</button>

    </div>
  );
}

export default Language;

const styles = {
  container: {
    height: "100vh",
    width: "100%",
    textAlign: "center",
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  topSection: {
    position: "relative",
    width: "100%",
    height: "35vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  topImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderBottomLeftRadius: "50% 30%",
    borderBottomRightRadius: "50% 30%",
  },

  logo: {
    position: "absolute",
    width: "120px",
    backgroundColor: "rgba(177, 91, 91, 0.9)",
    borderRadius: "12px",
    padding: "5px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },

  title: {
    marginTop: "20px",
    fontSize: "20px",
    fontWeight: "bold",
  },

  subtitle: {
    fontSize: "14px",
    color: "gray",
    padding: "0 40px",
    marginBottom: "30px",
  },

  buttonGroup: {
    width: "80%",
    maxWidth: "300px",
    display: "flex",
    flexDirection: "column",
  },

  btn: {
    width: "100%",
    padding: "15px",
    margin: "8px 0",
    borderRadius: "12px",
    border: "1px solid #eee",
    background: "#f5f5f5",
    fontSize: "16px",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },

  activeBtn: {
    width: "100%",
    padding: "15px",
    margin: "8px 0",
    borderRadius: "12px",
    background: "#1a1a1a",
    color: "white",
    fontSize: "16px",
    border: "none",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
  },

  selectBtn: {
    width: "85%",
    padding: "16px",
    marginTop: "auto",
    marginBottom: "30px",
    borderRadius: "15px",
    background: "#ff1e1e",
    color: "white",
    border: "none",
    fontSize: "18px",
    fontWeight: "bold",
    boxShadow: "0 4px 15px rgba(255, 30, 30, 0.3)",
    cursor: "pointer",
  },
};